<template>
  <div class="vehicleApplyPage" v-if="!this.showLoad">
    <div class="applyFrom">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.licensePlateNumber"
          label="车牌号："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.brandName"
          label="品牌："
          input-align="right"
          readonly
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.unitCost"
          label="费用（元/公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.currentMileage"
          label="当前里程（公里）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.seatingCapacity"
          label="座位数（个）："
          readonly
          input-align="right"
          class="ggInput"
        />
      </van-cell-group>
      <!-- 申请内容 -->
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone baseSalary moreText">
        <van-field
          v-model="baseData.projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          :placeholder="editType ? '请选择' : ''"
          @click="checkItemPicker"
          :is-link="editType"
          readonly
          rows="1"
          autosize
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          label="用车开始时间："
          v-model="baseData.startTime"
          :required="editType"
          @click="TimePicker(1)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          label="用车结束时间："
          :required="editType"
          v-model="baseData.endTime"
          @click="TimePicker(2)"
          :is-link="editType"
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox moreText">
        <van-field
          v-model="baseData.destination"
          label="前往地点："
          :required="editType"
          autosize
          input-align="right"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox beizhu">
        <van-field
          v-model="baseData.reason"
          label="用车原因："
          rows="1"
          :required="editType"
          autosize
          type="textarea"
          input-align="right"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
    </div>

    <!-- 审批流程 -->
    <div
      class="approveList"
      v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
    >
      <audit-list :applicantData="baseData"></audit-list>
    </div>

    <!-- 流程图 -->
    <div
      class="flowList"
      v-if="this.mode != 'add' && baseData.verifyStatus != 'hold'"
    >
      <flow-staff :applicantData="baseData"></flow-staff>
      <flow-list :workflowCode="baseData.workflowCode"></flow-list>
    </div>
    <!-- 审批 -->
    <van-popup
      v-model="verifyPageType"
      closeable
      round
      close-icon="close"
      position="bottom"
      class="verifyPage"
    >
      <verify-main :applicantData="baseData"  @changeVerifyType="setVerifyType"></verify-main>
    </van-popup>
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn fr"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn fr"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import {
  getCurData,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
} from "@/utils/common";
import { getDeviceType, closePage, is_wei} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const projectView = () => import("@/components/businessTripMould/projectView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
export default {
  name: "vehicleApply", //车辆申请   新增/编辑/查看
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
    projectView,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      commonType: "", // 返回当前表单时 新增 ？查看？ 编辑？
      commonId: "", //编辑Id

      mode: "",
      editType: false, //当前表单是否可以编辑-- 默认不可编辑
      baseData: {
        carId: "",
        licensePlateNumber: "",
        brandName: "",
        currentMileage: "",
        seatingCapacity: "",
        unitCost: "",
        projectId: "", //项目编号
        projectName: "", //项目名称
        destination: "", //目的地
        startTime: "", //出发时间
        endTime: "", //回程时间
        reason: "", //用车原因
        annexes: [],
        verifyStatus: "hold",
      },
      showItemPicker: false, //所属项目弹框
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(getCurData()),
      checkIndex: "", // 获取证书发放和到期时间
      clineType: getDeviceType(),
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      sendType: "", //判断是否在抄送列表
      addType: false, //防止高频点击
    };
  },

  mounted() {
     if(is_wei()){
      document.title="用车申请";
    }
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.commonId = this.$route.query.commonId; //申请Id
    this.baseData.carId = this.$route.query.carId; //车辆id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
        if (this.commonType == "add") {
          this.setShowLoad(false); //将loading状态隐藏
          this.editType = true;
          this.getCarMsg();
        } else {
          this.setShowLoad(false); //将loading状态隐藏
          this.initPage();
        }
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    getCarMsg() {
      //获取车辆信息
      let _this = this;
      _this.$api.material.vehicleApply
        .carDetails(_this.baseData.carId)
        .then((res) => {
          if (res.code == "1") {
            _this.baseData.licensePlateNumber = res.data.licensePlateNumber;
            _this.baseData.brandName = res.data.brandName;
            _this.baseData.currentMileage = res.data.currentMileage;
            _this.baseData.seatingCapacity = res.data.seatingCapacity;
            _this.baseData.unitCost = res.data.unitCost;
          } else {
            if (res.data == null) {
              let text = "无法获取车辆信息";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    initPage() {
      let _this = this;
      //编辑时条用的详情
      _this.$api.material.vehicleApply
        .detailsUseCar(this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = newApi.assign({}, _this.baseData, res.data);
            _this.$set(_this.baseData, "applyTypeName", "用车");
            _this.baseData.projectName =
              _this.baseData.projectName == null
                ? ""
                : _this.baseData.projectName;
            if (
              (_this.baseData.verifyStatus == "hold" ||
                _this.baseData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.baseData.verifyStatus == "hold" ? "删除" : "撤回";

      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.$api.material.vehicleApply
            .deleteRecall(this.baseData.verifyStatus, _this.baseData.id)
            .then((res) => {
              if (res.code == "1") {
                let ss = text + "成功";
                closePage(ss);
              } else {
                _this.$toast(res.msg);
              }
            });
        });
    },
    TimePicker(type) {
      if (this.editType) {
        this.checkIndex = type;
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      console.log(data);
      if (this.checkIndex == "1") {
        this.baseData.startTime = dateTimeFormat(data);
      } else {
        this.baseData.endTime = dateTimeFormat(data);
      }
    },
    /*显示所属项目控件*/
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    /*获取所属项目数据*/
    setProject(data) {
      if (data != "") {
        this.baseData.projectId = data.id;
        this.baseData.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    checkInput() {
       
      if (
        this.baseData.projectName == "" ||
        this.baseData.startTime == "" ||
        this.baseData.endTime == "" ||
        this.baseData.reason == "" ||
        this.baseData.destination == ""
      ) {
        this.$toast("带星号为必填，不能为空");
          
      } else {
         this.btnLoading = true;
        this.saveCarApply();
      }
    },
    saveCarApply() {
      //提交用车申请
      let _this = this;
      // let addData = _this.baseData;
      // let updateData = {
      //   annexes: null,
      //   carId: _this.baseData.carId,
      //   destination: _this.baseData.destination,
      //   endTime: _this.baseData.endTime,
      //   id: _this.baseData.id,
      //   reason: _this.baseData.reason,
      //   startTime: _this.baseData.startTime
      // };

      // let params = _this.mode == "add" ? _this.baseData : updateData;

      _this.$api.material.vehicleApply
        .addEditUseCar(_this.mode, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
             this.btnLoading = false;
          }
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          if (this.commonType == "add") {
            this.setShowLoad(false); //将loading状态隐藏
            this.editType = true;
            this.getCarMsg();
          } else {
            this.setShowLoad(false); //将loading状态隐藏
            this.initPage();
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.vehicleApplyPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: scroll;
  padding-bottom: 80px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseSalary {
    box-sizing: border-box;

    .van-cell:not(:last-child)::after {
      content: none;
    }
  }
  .ggInput {
    border-bottom: 1px solid #f6f6f6;
  }
  .summaryBox {
    min-height: 45px;
    margin-bottom: 2px;

    .van-cell__title {
      span {
        font-size: 15px;
      }
    }
    .van-cell__value {
      .van-field__control {
        color: #969799;
        font-size: 15px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  .enableBox {
    .van-cell {
      border-bottom: 1px solid #f6f6f6;
    }
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
}
</style>